define('WeltPixel_CategoryPage/js/swatch-renderer',[
    'jquery',
    'priceUtils'
], function ($, priceUtils) {
    'use strict';

    return function (widget) {

        $.widget('mage.SwatchRenderer', widget, {
            _create: function () {
                this._super();
                var options = this.options,
                productData = this._determineProductData(),
                $main = productData.isInProductView ?
                        this.element.parents('.column.main') :
                        this.element.parents('.product-item-info');


                var lazyLoadActivated = $main.find('.product-image-photo').attr('data-original');
                if (lazyLoadActivated && !productData.isInProductView) {
                    options.mediaGalleryInitial = [{
                        'img': lazyLoadActivated
                    }];
                }
            },

            _setPreSelectedGallery: function () {
                this._super();
                var swatchPreselectLimit = 'all',
                        applySwatchPreselect = true;
                if ($('body.page-products').length) {
                    if (applySwatchPreselect) {
                        var $colorFilter = $('li.mst-nav__state-filter[data-attribute_code="color"]');
                        var colorOptionIds = [];
                        if ($colorFilter.length) {
                            colorOptionIds = $colorFilter.attr('data-option_id').split(',');
                        }

                        var index = 0;
                        $(this.element).find('.swatch-attribute').each(function () {
                            var $swatchAttr = $(this);
                            var displayedSwatches = $swatchAttr.find('.swatch-option').length;

                            // Erweiterung: Wenn color-Filter aktiv, passende Option wählen
                            if ($swatchAttr.hasClass('color') && colorOptionIds.length) {
                                var found = false;
                                colorOptionIds.forEach(function(optId) {
                                    var $option = $swatchAttr.find('.swatch-option[data-option-id="' + optId + '"]');
                                    if ($option.length) {
                                        $option.first().trigger('click');
                                        found = true;
                                    }
                                });
                                if (found) return; // Keine weitere Vorwahl!
                            }

                            // Standardverhalten
                            // var displayedSwatches = $(this).find('.swatch-option').length;
                            // if (index == 0) {
                            //     $(this).find('.swatch-option').first().trigger('click');
                            //     index++;
                            // } else {
                            //     $(this).find('.swatch-option.selected').first().trigger('click');
                            // }
                        });
                    }
                }

                if ($('body.catalog-product-view').length) {
                    if (applySwatchPreselect) {
                        let element = $(this.element);
                        let stop = false;

                        if (element.find('.swatch-attribute').length >= 2) {
                            element.find('.swatch-attribute.color .swatch-option').each(function () {
                                if (stop) return false;

                                $(this).trigger('click');

                                element.find('.swatch-attribute.size .swatch-option').each(function () {
                                    if (!$(this).hasClass('out-stock')) {
                                        $(this).trigger('click');
                                        stop = true;
                                        return false;
                                    }
                                });
                            });
                        } else {
                             element.find('.swatch-attribute').each(function () {
                                var $swatchAttr = $(this);
                                var displayedSwatches = $swatchAttr.find('.swatch-option').length;
    
                                // Standardverhalten
                                $(this).find('.swatch-option').first().trigger('click');
                            });   
                        }
                    }
                }
            },


            _UpdatePrice: function () {
                this._super();
                var $widget = this;
                $widget._UpdateSalePrice();
            },

            _UpdateSalePrice: function () {
                var $widget = this,
                    wpSalesMsgWrapperSelector = '.wp-sales-off-msg',
                    wpSalesDiscountPercentSelector = '#wp-discount-percent',
                    wpSalesDiscountValueSelector = '#wp-discount-value',
                    result = $widget._getNewPrices();

                if ($(wpSalesMsgWrapperSelector).length) {
                    if (typeof result != 'undefined' && result.oldPrice.amount !== result.finalPrice.amount) {
                        var discountPercent =  100 - Math.round((result.finalPrice.amount * 100) / result.oldPrice.amount);
                        var discountValue =  priceUtils.formatPrice(result.oldPrice.amount -  result.finalPrice.amount);
                        $(wpSalesDiscountPercentSelector).html(discountPercent);
                        $(wpSalesDiscountValueSelector).html(discountValue);
                        $(wpSalesMsgWrapperSelector).show();
                    } else {
                        $(wpSalesMsgWrapperSelector).hide();
                    }
                }
            }
        });

        return $.mage.SwatchRenderer;
    }
});

